//Reselect selector
//Takes a driver allocation object and retrieves the required driver allocation properties

import { createSelector } from 'reselect';
import {
  setDefaultSource,
  getCountries
} from '../../../utils/helpers/costcenter';

import {getFilterCountries} from '../../../utils/globalSelectors';


// Create select function to pick off the pieces of state we care about for this calculation
const getDriverAllocationSelector = (state) => state.relocation.driverAllocation;

const getDriverAllocationCostCenterSelector = (state) => state.common.costcenter;

const getDriverAllocationCountrySelector = (state) => state.common.country;

const getDriverAllocationDriversListSelector = (state) => state.relocation.driverAllocation.driverList;

//derieve/ extract the required props from the driver allocation object
const getDriverAllocationProps = (driverAllocation) => {
	const {
    fetchingDrivers,
    driverList,
    totalDrivers,
    fetchingDriverAllocationDetails,
    driverAllocationDetails,
    fetchingDriverDetails,
    driverDetails
  } = driverAllocation;

  return {
    fetchingDrivers,
    driverList,
    totalDrivers,
    fetchingDriverAllocationDetails,
    driverAllocationDetails,
    fetchingDriverDetails,
    driverDetails
  };
};

const getDynamicFilterData = state => state.common.dynamicFilters;

const getRestrictionFilterSelector = dynamicFilters => {
  let restrictions = [];

  if (dynamicFilters && dynamicFilters.length > 0) {
    dynamicFilters.forEach((item) => {
      if(item.value.length <= 0) return;

      restrictions.push({
        typeId: item.typeId,
        values: item.value.map((val) => val.value)
      })
    });
  }

  return {restrictions};
};

const getDriverAllocationCCAndCountryProps = (costcenter,country,countries) => {
	return setDefaultSource(
    country,
    costcenter,
    countries
  );
};

export const getDriverAllocation = createSelector(getDriverAllocationSelector,  //pick off a piece of state
	getDriverAllocationProps // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);

export const getDriverAllocationCCAndCountry = createSelector(getDriverAllocationCostCenterSelector,getDriverAllocationCountrySelector,getFilterCountries,getDriverAllocationCCAndCountryProps);

export const getRestrictionFilter = createSelector(
  getDynamicFilterData,
  getRestrictionFilterSelector
);




// WEBPACK FOOTER //
// ./src/features/relocations/driver/selector.js